import clsx from 'clsx';

const sizes = {
  sm: 'h-8 w-4',
  md: 'h-16 w-8',
  lg: 'h-24 w-16',
  xl: 'h-32 w-24',
};

const variants = {
  light: 'text-white',
  primary: 'text-primary',
};

export type SpinnerProps = {
  size?: keyof typeof sizes;
  variant?: keyof typeof variants;
  className?: string;
};

export const Spinner = ({ size = 'md', variant = 'primary', className = '' }: SpinnerProps) => {
  return (
    <div
      className={clsx(
        'animate-pulse items-center flex flex-col',
        sizes[size],
        variants[variant],
        className
      )}
    >
      <span>Loading</span>
    </div>
  );
};
